// extracted by mini-css-extract-plugin
export var btn = "TransparentButton-module--btn--2m9iu";